import {
  ErrorResponseCodeType,
  EndPointsNames,
  ApiCredentialsType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/members/dependents';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_AUTH_USER';
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/Conta~1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/05625819-ecc8-4f35-9b27-50f2d7b7e897';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
  {
    code: '11',
    bussinessErrorVariant: 'wrongParams',
    message: 'Parametros de entrada inválido',
  },
  {
    code: '2',
    bussinessErrorVariant: 'userNotFound',
    message: 'Conta não possui dependentes ou responsável.',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
